import type { ProjectionState } from "@/lib/api/reports";
import { relative } from "@/lib/format";

/**
 * Proyeksiya kechikishi.
 *
 * Hisobot CQRS read model: u manbadan orqada qoladi.
 * `reporting-service` buni `GET /reports-status` da ochiq beradi va
 * interfeys ham YASHIRMAYDI — hisobotni ko'rgan odam ma'lumot
 * qanchalik yangi ekanini bilishi kerak.
 */
export function ProjectionLag({ status }: { status?: ProjectionState[] }) {
  if (!status || status.length === 0) return null;

  const failing = status.filter((item) => item.last_error);
  const newest = status
    .map((item) => item.last_event_at)
    .filter(Boolean)
    .sort()
    .at(-1);

  if (failing.length > 0) {
    return (
      <span className="lag lag-error" title={failing[0]!.last_error}>
        <span className="lag-dot" />
        {failing.length} oqimda xato
      </span>
    );
  }

  const stale = newest ? Date.now() - new Date(newest).getTime() > 5 * 60_000 : false;

  return (
    <span className={`lag${stale ? " lag-stale" : ""}`} title="Oxirgi qayta ishlangan hodisa">
      <span className="lag-dot" />
      Ma'lumot: {relative(newest)}
    </span>
  );
}
